// extracted by mini-css-extract-plugin
export default {"spinner":"CandyCaneSpinner_spinner__mDri6","candy_cane_spinner":"CandyCaneSpinner_candy_cane_spinner__Mwl3j"};